import OPushSegmentSelection from './index.vue';

OPushSegmentSelection.install = app => {
  app.component(OPushSegmentSelection.name, OPushSegmentSelection);
};

export default OPushSegmentSelection;
